import { render, staticRenderFns } from "./DictCheckBoxGroup.vue?vue&type=template&id=cfbf71e6"
import script from "./DictCheckBoxGroup.vue?vue&type=script&lang=js"
export * from "./DictCheckBoxGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports